"use client"

import { Refresh as Loader2, TrashBinTrash as Trash2 } from "@papier/ui/components/icons"
import type { ComponentProps, ReactNode } from "react"
import { useFormState } from "react-hook-form"

import { cn } from "@papier/ui/lib/utils"
import { Button } from "@papier/ui/components/ui/button"
import type { SettingsCardClassNames } from "./settings-card"

interface SettingsActionButtonProps extends ComponentProps<typeof Button> {
    classNames?: SettingsCardClassNames
    actionLabel: ReactNode
    disabled?: boolean
    isSubmitting?: boolean
}

export function SettingsActionButton({
    classNames,
    actionLabel,
    disabled,
    isSubmitting,
    variant,
    onClick,
    ...props
}: SettingsActionButtonProps) {
    if (!onClick) {
        const formState = useFormState()
        isSubmitting = formState.isSubmitting
    }

    return (
        <Button
            className={cn(
                "md:ms-auto",
                classNames?.button,
                variant === "default" && classNames?.primaryButton,
                (variant === "destructive" || variant === "destructive-outline") && classNames?.destructiveButton
            )}
            disabled={isSubmitting || disabled}
            size="default"
            type={onClick ? "button" : "submit"}
            variant={variant}
            onClick={onClick}
            {...props}
        >
            {isSubmitting ? <Loader2 className="animate-spin" aria-hidden="true" /> : variant === "destructive-outline" && <Trash2 className="size-4" aria-hidden="true" />}
            {actionLabel}
        </Button>
    )
}
